module.exports = class ProfileService {

  static $inject =[
    '$http',
  ];

  constructor($http) {
    this.$http = $http;
  }

  getNotification(patient, groupId, callback) {
    this.$http.get('/api/v2/appointments/period_opening_notifications/', {
      params: {
        patient_id: patient.id,
        group_id: groupId,
      },
    }).then((response) => {
      if (callback) {
        callback(response);
      }
      return response;
    });
  }

  putNotification(info, callback) {
    return this.$http.put('/api/v2/appointments/period_opening_notifications/', {
      patient_id: info.patient_id,
      group_id: info.group_id,
      notifications: info.notifications,
    })
      .then(callback);
  }
};



// WEBPACK FOOTER //
// ./profile/services/profile-service.js